export default __webpack_public_path__ + "static/media/field-evaluation.bf0403da.jpg";